import { css } from '@styled-system/css';
import type { InputHTMLAttributes } from 'react';

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'className'> {
  className?: string;
}

export const Input = ({ className, ...props }: InputProps) => {
  const inputStyles = css({
    w: 'full',
    px: 'sm', // 10px padding horizontal
    py: 'sm', // 10px padding vertical
    border: '0.046875rem solid',
    borderColor: 'base.border', // #1e1f24
    rounded: 'sm', // 6px border radius
    bg: 'transparent',
    outline: 'none',

    // Typography du design
    fontSize: 'sm', // 11px
    fontWeight: 'medium', // Manrope Medium
    fontFamily: 'Manrope, sans-serif',
    lineHeight: '1.07',
    color: 'font.primary', // Couleur du texte saisi

    // Placeholder styling
    _placeholder: {
      color: 'font.lowkey', // #4f5055
    },

    // Focus state
    _focus: {
      outline: 'none',
      borderColor: 'accent.primary',
    },

    // Disabled state
    _disabled: {
      opacity: 0.6,
      cursor: 'not-allowed',
    },
  });

  return <input className={`${inputStyles} ${className || ''}`} {...props} />;
};
